<template>
    <div>
        <ul class="nav nav-tabs">
            <li class="nav-item">
                <router-link class="nav-link" :to="{name: 'tx.txs'}">Tx count</router-link>
            </li>
            <li class="nav-item">
                <router-link class="nav-link" :to="{name: 'tx.fee'}">Tx fee (sat)</router-link>
            </li>
        </ul>
        <div class="lol-window-chart">
        <transition name="fade">
            <router-view></router-view>
        </transition>
        </div>
    </div>
</template>

<script>
export default {
    name: 'tx'
}
</script>
<style>
</style>




// WEBPACK FOOTER //
// tx.vue?77f90b05